export const CARD_TYPES = {
	CALL_TO_ACTION: 'call-to-action',
	CALL_TO_ACTION_INTERNAL: 'call-to-action-internal',
	CALL_TO_ACTION_GENERAL: 'call-to-action-general',
	CALL_TO_ACTION_LEAD: 'call-to-action-lead',
	CALL_TO_ACTION_REFERRAL: 'call-to-action-referral',
	JOB_ALERTS: 'job-alerts',
	OPEN_JOBS: 'open-jobs',
	LEADERBOARD: 'leaderboard',
	YOUR_REFERRALS: 'your-referrals',
	POINTS_RANKING: 'points-ranking',
	REFERRALS_RANKING: 'referrals-ranking',
	CUSTOM_HTML: 'custom-html',
	ANNOUNCEMENTS: 'announcements',
	RECENT_JOBS: 'recent-jobs',
	ANNOUNCEMENT_THUMBNAIL: 'announcement-thumbnail',
	RECOGNITION_SHOUTOUTS: 'recognition-shoutouts',
	MY_RECOGNITIONS: 'my-recognitions',
	CALL_TO_ACTION_RECOGNITION: 'call-to-action-recognition',
	RECOGNITION_LEADERBOARD: 'recognition-leaderboard',
};

export const DEFAULT_CARD_DATA = {
	[CARD_TYPES.CALL_TO_ACTION]: {
		title: 'YOUR',
		subtitle: 'TEXT HERE',
		buttonText: 'EXTERNAL LINK',
		link: '',
		backgroundColor: '#EF3C3F',
		borderColor: '#EF3C3F',
		textColor: '#ffffff',
		showBorder: false,
		borderSize: 1,
		buttonBackground: '#ffffff',
		buttonTextColor: '#3076bb',
	},
	[CARD_TYPES.CALL_TO_ACTION_REFERRAL]: {
		title: 'REFER',
		subtitle: 'YOUR FRIENDS',
		buttonText: 'SEND A REFERRAL',
		link: '/browsejobs',
		backgroundColor: '#e75da7',
		borderColor: '#e75da7',
		textColor: '#ffffff',
		showBorder: false,
		borderSize: 1,
		buttonBackground: '#ffffff',
		buttonTextColor: '#3076bb',
	},
	[CARD_TYPES.CALL_TO_ACTION_GENERAL]: {
		title: 'SUBMIT',
		subtitle: 'A GENERAL REFERRAL',
		buttonText: 'SUBMIT REFERRAL',
		backgroundColor: '#7942e7',
		borderColor: '#7942e7',
		textColor: '#ffffff',
		link: '/browsejobs',
		showBorder: false,
		borderSize: 1,
		buttonBackground: '#ffffff',
		buttonTextColor: '#3076bb',
	},
	[CARD_TYPES.CALL_TO_ACTION_LEAD]: {
		title: 'SUBMIT',
		subtitle: 'A REFERRAL LEAD',
		buttonText: 'SUBMIT REFERRAL',
		backgroundColor: '#f7a34d',
		borderColor: '#f7a34d',
		textColor: '#ffffff',
		link: '/myreferrals',
		showBorder: false,
		borderSize: 1,
		buttonBackground: '#ffffff',
		buttonTextColor: '#3076bb',
	},
	[CARD_TYPES.CALL_TO_ACTION_INTERNAL]: {
		title: 'APPLY',
		subtitle: '& GROW YOUR CAREER',
		buttonText: 'APPLY INTERNALLY',
		backgroundColor: '#14d6d3',
		borderColor: '#14d6d3',
		textColor: '#ffffff',
		link: '/internal',
		showBorder: false,
		borderSize: 2,
		buttonBackground: '#ffffff',
		buttonTextColor: '#3076bb',
	},
	[CARD_TYPES.JOB_ALERTS]: {
		title: 'New Jobs Added',
		subtitle: 'Matching Your Preferences',
		tooltipText:
			'These are new job matches from the last 14 days that match your criteria.',
		buttonText: 'VIEW JOBS',
		link: '/browsejobs/new',
		backgroundColor: '#f7a34d',
		borderColor: '#f7a34d',
		textColor: '#ffffff',
		countColor: '#000000',
		showBorder: false,
		borderSize: 2,
		buttonBackground: '#ffffff',
		buttonTextColor: '#3b82f6',
	},
	[CARD_TYPES.OPEN_JOBS]: {
		title: 'Jobs',
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#666666',
		statColor: '#000000',
		showBorder: true,
		borderSize: 1,
		link: '/browsejobs',
	},
	[CARD_TYPES.LEADERBOARD]: {
		title: 'Leaderboards',
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#666666',
		showBorder: true,
		borderSize: 1,
		showReferralsRanking: true,
		showPointsRanking: true,
	},
	[CARD_TYPES.YOUR_REFERRALS]: {
		title: 'Your Referrals',
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#666666',
		showBorder: true,
		borderSize: 1,
		referralsBackgroundColor: '#ffffffff',
		referralsBorderColor: '#dddddd',
		referralsTextColor: '#000000',
		referralsTotalColor: '#0686d0',
		bonusesBackgroundColor: '#6cb761',
		bonusesBorderColor: '#c4d5c1ff',
		bonusesTextColor: '#ffffff',
		bonusesTotalColor: '#ffffff',
	},
	[CARD_TYPES.POINTS_RANKING]: {
		title: 'Points Ranking',
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#666666',
		statColor: '#000000',
		showBorder: true,
		borderSize: 1,
	},
	[CARD_TYPES.REFERRALS_RANKING]: {
		title: 'Referrals Ranking',
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#666666',
		statColor: '#000000',
		showBorder: true,
		borderSize: 1,
		arrowUpColor: '#19bb4b',
		arrowDownColor: '#ff4d4d',
	},
	[CARD_TYPES.CUSTOM_HTML]: {
		title: 'Custom HTML',
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#666666',
		showBorder: true,
		borderSize: 1,
		htmlContent:
			'<div style="text-align: center; padding: 10px;">\n  <h2>Welcome to the Dashboard!</h2>\n  <p>Customize this card with your own HTML content.</p>\n</div>',
		hideTitle: false,
		removePadding: false,
	},
	[CARD_TYPES.ANNOUNCEMENTS]: {
		title: 'Announcements',
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#666666',
		showBorder: true,
		borderSize: 1,
		announcementsAmount: 5,
	},
	[CARD_TYPES.RECENT_JOBS]: {
		title: 'Hot Jobs',
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#666666',
		showBorder: true,
		borderSize: 1,
		showHotJobsOnly: true,
		jobsAmount: 3,
	},
	[CARD_TYPES.ANNOUNCEMENT_THUMBNAIL]: {
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#333333',
		showBorder: true,
		borderSize: 1,
		announcementPosition: 1,
	},
	[CARD_TYPES.RECOGNITION_SHOUTOUTS]: {
		title: 'Recognition Shoutouts',
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#333333',
		showBorder: true,
		borderSize: 1,
		shoutoutsLimit: 2,
	},
	[CARD_TYPES.CALL_TO_ACTION_RECOGNITION]: {
		title: 'SEND',
		subtitle: 'A RECOGNITION',
		buttonText: 'SEND RECOGNITION',
		link: '/recognition-hub',
		backgroundColor: '#f3cd5d',
		borderColor: '#f3cd5d',
		textColor: '#ffffff',
		showBorder: false,
		borderSize: 1,
		buttonBackground: '#ffffff',
		buttonTextColor: '#3076bb',
	},
	[CARD_TYPES.MY_RECOGNITIONS]: {
		title: 'My Recognitions',
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#333333',
		showBorder: true,
		borderSize: 1,
		badgesAmount: 2,
	},
	[CARD_TYPES.RECOGNITION_LEADERBOARD]: {
		title: 'Recognition Leaderboard',
		backgroundColor: '#ffffff',
		borderColor: '#dddddd',
		textColor: '#666666',
		showBorder: true,
		borderSize: 1,
		showSubCompanyFilter: false,
	},
};

export function getDefaultCardData(type) {
	return DEFAULT_CARD_DATA[type] || {};
}
